import React from 'react';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

const { Order, Customer, UI } = Mobi2Go;

export default forwardRefWithTranslation('order.available-rewards-indicator')(
    class AvailableRewardsIndicator extends React.Component {
        constructor() {
            super();

            this.state = {
                available_rewards: Order.getAvailableRewards(),
                isDatacandyEnabled: Customer.getLoyalty('DataCandyLoyalty')
            };

            Order.bind({
                updateAvailableRewards: available_rewards =>
                    this.setState({ available_rewards }),
            });
        }

        onClick = () => {
            UI.trigger('showCustomerRewards');
        };

        render() {
            const { available_rewards, isDatacandyEnabled } = this.state;
            if (!available_rewards.length) {
                return null;
            }

            if (isDatacandyEnabled) {
                return null;
            }
            
            const { t } = this.props;
            return (
                <div className="m2g-order-available-rewards-indicator">
                    <div
                        className="m2g-order-available-rewards-indicator-link"
                        onClick={this.onClick}
                    >
                        {t('indicator_label', {
                            count: available_rewards.length,
                            reward_label: t('customer.rewards:label'),
                        })}
                    </div>
                </div>
            );
        }
    }
);
